import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {ToolItem} from '@pb/kit-component-tools-ribbon';

type Props = {
    totalCount: number,
    selectedCount: number,
    onSelectAll: () => void,
};

export const SelectAllView: React.FC<Props> = ({totalCount, selectedCount, onSelectAll}) => {
    const show = totalCount > 0 && selectedCount < totalCount;
    if (!show) {
        return null;
    }

    return (
        <ToolItem>
            <FlatButton onClick={onSelectAll}>Select All</FlatButton>
        </ToolItem>
    );
};
